import days from 'constants/days';

import hours, {
  hoursMap
} from 'constants/hours';

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('sequenceStepCustomHours', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/sequence_step_custom_hours.html.slim'),
    scope: {
      condition: '=',
      sequence: '='
    },
    controller: ["$rootScope", "$scope", "$filter", function($rootScope, $scope, $filter) {
      var getTooltipContent, gym, gymSequenceDetail;
      gym = $rootScope.gym;
      gymSequenceDetail = gym.gym_sequence_detail;
      $scope.days = days.map(function(day) {
        return {
          id: day.value,
          name: $filter('humanize')(day.label)
        };
      });
      $scope.hours = hours.map(function(hour) {
        return {
          id: hour.value,
          name: hour.label
        };
      });
      $scope.hoursUnitSelected = function() {
        return ($scope.condition.time_since_previous_step_unit === 'hours' || $scope.condition.trigger_time_unit === 'hours') && !$scope.condition.immediate;
      };
      $scope.isTooltipVisible = function() {
        var hasRestrictedHours;
        hasRestrictedHours = gymSequenceDetail && (gymSequenceDetail.no_comms_payloads_before_hour || gymSequenceDetail.no_comms_payloads_after_hour);
        return hasRestrictedHours && !$scope.hoursUnitSelected();
      };
      getTooltipContent = function() {
        var channels, hoursDesc;
        if (!$scope.isTooltipVisible()) {
          return;
        }
        channels = gym.mobile_app_enabled ? 'Emails, SMSes and Push Notifications' : 'Emails and SMSes';
        hoursDesc = gymSequenceDetail.no_comms_payloads_before_hour && gymSequenceDetail.no_comms_payloads_after_hour ? `${channels} will only be sent during the hours of ${hoursMap[gymSequenceDetail.no_comms_payloads_before_hour].label} - ${hoursMap[gymSequenceDetail.no_comms_payloads_after_hour].label}.` : gymSequenceDetail.no_comms_payloads_before_hour ? `${channels} will not be sent before ${hoursMap[gymSequenceDetail.no_comms_payloads_before_hour].label}.` : gymSequenceDetail.no_comms_payloads_after_hour ? `${channels} will not be sent after ${hoursMap[gymSequenceDetail.no_comms_payloads_after_hour].label}.` : void 0;
        return `${hoursDesc}
<br/>
All other ${featureNames.SEQUENCE_LOWERCASE} actions can happen at any time, unless restricted here.`;
      };
      return $scope.tooltipContent = getTooltipContent();
    }]
  };
});
